'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleOpmlError = handleOpmlError;

var _BaseError2 = require('./BaseError');

var _BaseError3 = _interopRequireDefault(_BaseError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OpmlError = function (_BaseError) {
  _inherits(OpmlError, _BaseError);

  function OpmlError(opmlResponse) {
    _classCallCheck(this, OpmlError);

    var _this = _possibleConstructorReturn(this, (OpmlError.__proto__ || Object.getPrototypeOf(OpmlError)).call(this, opmlResponse.statusText));

    _this.name = 'OpmlError';
    _this.message = opmlResponse.statusText;
    _this.statusCode = opmlResponse.status;
    _this.faultCode = opmlResponse.faultCode;
    return _this;
  }

  return OpmlError;
}(_BaseError3.default);

// API promise handlers
// Mainly for login and logout, as OPML tends to return errors detailed in response body with 200
// response status codes, instead of proper non-200 ones.


exports.default = OpmlError;
function handleOpmlError(response) {
  var head = response.data.head;

  if (head && head.status >= 300) {
    throw new OpmlError(head);
  }

  return response;
}
//# sourceMappingURL=OpmlError.js.map